import {
	createStore,
	createActionsHook,
	createStateHook,
	createContainer,
} from '@atlassian/react-sweet-state';
import { actions, type Actions } from './actions';
import type { SelectedIssuesState, ContainerProps } from './types';

const initialState: SelectedIssuesState = {
	selectedIssueIds: new Set([]),
};

export const IssueTableSelectedIssuesContainer = createContainer<ContainerProps>();

const Store = createStore<SelectedIssuesState, Actions, ContainerProps>({
	initialState,
	actions,
	name: 'jira-native-issue-table-selected-issues-state',
	containedBy: IssueTableSelectedIssuesContainer,
});

export const useIssueTableSelectedIssuesActions = createActionsHook<
	SelectedIssuesState,
	typeof actions
>(Store);

const getSelectedIssueIdsSelector = (state: SelectedIssuesState): String[] => {
	return Array.from(state.selectedIssueIds);
};

export const useIssueTableSelectedIssues = createStateHook(Store, {
	selector: getSelectedIssueIdsSelector,
});

const getIsIssueIdSelectedSelector = (state: SelectedIssuesState, issueId: string): boolean => {
	return state.selectedIssueIds.has(issueId);
};

export const useIsIssueSelected = createStateHook(Store, {
	selector: getIsIssueIdSelectedSelector,
});
